import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { RoutePath } from '@nano/common/routing/routing';
import { AuthService } from '@nano/core/auth';

@Injectable({ providedIn: 'root' })
export class NotLoggedInGuard {
  constructor(
    private router: Router,
    private authService: AuthService
  ) {}

  canActivate(): boolean {
    return this.checkUserNotAuthorized();
  }

  canActivateChild(): boolean {
    return this.canActivate();
  }

  canLoad(): boolean {
    return this.checkUserNotAuthorized();
  }

  checkUserNotAuthorized(): boolean {
    if (!this.authService.isAuthorized()) {
      return true;
    }
    void this.router.navigate([`/${RoutePath.root}`]);
    return false;
  }
}
